import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs/operators';
import { RegistrationFlowService } from '../registration-flow/registration-flow.service';

/**
 * Blocks access to a registration step route when that step is not part of the user's flow.
 * Set `registrationFlowStep` in route data to the step identifier to guard.
 * Fetches the steps itself (cached after first call) so it does not depend on the resolver order.
 */
export const registrationFlowStepGuard: CanActivateFn = (route) => {
  const stepId: string = route.data['registrationFlowStep'];
  if (!stepId) {
    return true;
  }

  const flowService = inject(RegistrationFlowService);
  const router = inject(Router);

  return flowService.loadSteps().pipe(
    map((): boolean | UrlTree => {
      return flowService.isStepPresent(stepId) || router.createUrlTree(['/dashboard']);
    })
  );
};
